
import { defineComponent, ref, reactive, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { errManager, showNotification } from "@/core/config/Tools";
import { useStore } from "vuex";

import GlobalService from '@/core/services/GlobalService';

export default defineComponent({
    emits: ["onPersonResponse"],
    setup(props, { emit }) {
        const store = useStore();
        const loading = ref(false);
        const altura = screen.height;
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const form = reactive<any>({});
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            titleDialog.value = 'Registrar datos personales'
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    save()

            });
        };

        const save = async () => {
            loading.value = true
            await GlobalService.post('person/save', form)
                .then((res) => {
                    loading.value = false
                    showNotification(res.data)
                    if (res.data.status == 'success') {
                        isModalVisible.value = false
                        emit("onPersonResponse", res.data)
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })

        };

        const getDocuments: any = computed<any>(() => {
            return store.getters.currentUser.type_documents;
        })

        const getGender: any = computed<any>(() => {
            return store.getters.currentUser.gender;
        })

        /*
        const getUbigeo: any = computed<any>(() => {
            return store.getters.currentUser.ubigeo;
        })
        */

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const handleBlur = (e: FocusEvent) => {
            const input = e.target as HTMLInputElement
            const value = input.value.trim()

            // Permitir formato DD/MM/YYYY
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/
            if (regex.test(value)) {
                const [, day, month, year] = value.match(regex)!
                const formatted = `${year}-${month}-${day}` // convierte a formato ISO
                form.birthday = formatted
            }
        }


        return {
            loading,
            altura,
            titleDialog,
            isModalVisible,
            form,
            ruleFormRef,
            rules,

            //events
            openModal,
            onOpen,
            onClosed,
            submitForm,
            save,
            getDocuments,
            getGender,
            listCountry,
            handleBlur
        }

    },
})
